import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../reusable/GlobalMeta";
import InternalBanner from "../reusable/fieldGroups/InternalBanner";
import { Box, Container } from "@mui/system";
import PostsFilters from "./PostsFilters";
import { Grid, Skeleton, Typography } from "@mui/material";
import PostCard from "./PostCard";
import CustomPagination from "../reusable/CustomPagination";
import { useParams } from "react-router-dom";

export default function Posts() {
  const { pageNum = 1, categorySlug } = useParams();
  //Fetch posts page
  const [pageData, setPageData] = useState();
  const postsSlug = WP_API_Settings.posts_page_slug;
  //Track states for posts
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState();
  const [perPage, setPerPage] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [category, setCategory] = useState();
  const [topic, setTopic] = useState();
  const [search, setSearch] = useState();
  const categories = WP_API_Settings.category;
  const topics = WP_API_Settings.topic;

  useEffect(() => {
    //console.log(categorySlug)
    if (categorySlug) {
      let category = categories.find((cats) => cats.slug === categorySlug);
      setCategory(category);
    } else {
      setCategory();
    }
    //get parameter topic
    const urlParams = new URLSearchParams(window.location.search);
    let newTopic = urlParams.get("topic");
    //console.log(newTopic)
    if (newTopic) {
      let topic = topics.find((top) => top.slug === newTopic);
      setTopic(topic);
    } else {
      setTopic();
    }
  }, [categories, topics, categorySlug, window.location.search]);

  const { data } = useQuery(
    ["posts-page"], //Query key
    () =>
      axios({
        //Query function
        method: "get",
        url:
          WP_API_Settings.endpoint +
          "wp/v2/pages?slug=" +
          postsSlug +
          "&_embed=true&acf_format=standard",
      })
  );

  useEffect(() => {
    if (data?.data) {
      setPageData(data.data[0]);
    }
  }, [data]);

  //fetch posts
  const { data: posts_data } = useQuery(
    ["posts", pageNum, category?.term_id, search, perPage, topic?.term_id], //Query key
    () => {
      //set url params
      let params = {
        page: pageNum,
        per_page: perPage,
        search: search || null,
        _embed: true,
      };
      //check category
      if (category?.term_id) {
        params.categories = category?.term_id;
      }
      //check topic
      if (topic?.term_id) {
        params.topic = topic?.term_id;
      }
      return axios({
        //Query function
        method: "get",
        url: WP_API_Settings.endpoint + "wp/v2/posts",
        params: params,
      });
    }
  );

  useEffect(() => {
    if (posts_data) {
      //console.log(response)
      if (posts_data.data) {
        setPosts(posts_data.data);
      }
      setTotalPages(posts_data.headers["x-wp-totalpages"]);
      setLoading(false);
    }
  }, [posts_data]);

  return (
    <>
      <GlobalMeta />
      <InternalBanner
        featuredImage={
          pageData?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
        }
        banner={pageData?.acf?.internal_banner}
        isPosts
      />
      <Container maxWidth="xl">
        <PostsFilters
          page={pageNum}
          totalPages={totalPages}
          category={category}
          topic={topic}
          setSearchText={setSearch}
          setTopic={setTopic}
          setCategory={setCategory}
        />
        <Grid container spacing={2}>
          {loading ? (
            Array(perPage)
              .fill(0)
              .map(() => {
                return (
                  <Grid item xs={12} md={4}>
                    <Skeleton variant="rectangular" height={400} />
                  </Grid>
                );
              })
          ) : posts.length ? (
            posts.map((post, i) => {
              return (
                <Grid item xs={12} md={4}>
                  <PostCard post={post} index={i} />
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography
                variant="h3"
                component="p"
                sx={{
                  textAlign: "center",
                  color: "#005EAA",
                }}
              >
                No Insights found
              </Typography>
            </Grid>
          )}
          {posts && posts.length ? (
            <Grid item xs={12}>
              <Box
                sx={{
                  width: "fit-content",
                  m: "auto",
                }}
              >
                <CustomPagination
                  pageNum={parseInt(pageNum)}
                  totalPages={parseInt(totalPages)}
                  search={search}
                  category={category}
                  topic={topic}
                />
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </Container>
    </>
  );
}
